<template>
  <div class="mini-cart">
    <div class="cart-icon">
      <div class="cart-items-count">{{ totalLines }}</div>
    </div>
    <div class="cart-content">
      <div class="cart-content-inner">
        <div class="mini-cart-content">
          <div class="total-sum">
            {{ $t('basket.label.total') }}: {{ total / 100 }} €
          </div>
        </div>
        <div class="mini-cart-btn-wrap">
          <div class="cart-action">
            <a href="/account/cart">{{ $t('basket.button.cart') }}</a>
          </div>
          <div class="checkout-action">
            <a href="/account/checkout">{{ $t('basket.button.checkout') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniCart',
  data: function () {
    return {
      grandTotal: 0,
    }
  },
  computed: {
    total() {
      return this.$store.getters['basket/basketTotal']
    },
    totalQty() {
      return this.$store.getters['basket/basketQty']
    },
    totalLines() {
      return this.$store.getters['basket/basketTotalLines']
    },
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '')
    },
  },
}
</script>
